
const SubscriptionsPage = () => {
  return (
    <span>subscriptionsPage</span>
  );
  
};

export default SubscriptionsPage;
